module.exports = __webpack_public_path__ + "img/bfs.18628dd9.png";